import { On3IconPremiumPlus } from '@on3/icons';
import clsx from 'clsx';

import styles from './VerifiedEliteAthlete.module.scss';

interface IVerifiedAthleteProps {
  className?: string;
}
export const VerifiedEliteAthlete = ({ className }: IVerifiedAthleteProps) => {
  return (
    <div className={clsx(styles.block, className)}>
      <On3IconPremiumPlus />
      <span>Elite</span>
    </div>
  );
};
